export const linearRegression = (x: number[], y: number[]) => {
  const n = x.length;
  const sumX = x.reduce((a, b) => a + b, 0);
  const sumY = y.reduce((a, b) => a + b, 0);
  const sumXY = x.reduce((sum, xi, i) => sum + xi * y[i], 0);
  const sumX2 = x.reduce((sum, xi) => sum + xi * xi, 0);

  const slope = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
  const intercept = (sumY - slope * sumX) / n;

  return { slope, intercept };
};

export const calculateTrendLine = (
  data: (number | null)[],
): (number | null)[] => {
  const validData: { index: number; value: number }[] = [];
  data.forEach((value, index) => {
    if (value !== null && value !== undefined && !isNaN(value)) {
      validData.push({ index, value });
    }
  });

  if (validData.length < 2) {
    return data.map(() => null);
  }

  const xValues = validData.map((item) => item.index);
  const yValues = validData.map((item) => item.value);

  const { slope, intercept } = linearRegression(xValues, yValues);

  return data.map((_, index) => {
    if (validData.some((item) => item.index === index)) {
      return slope * index + intercept;
    }
    return null;
  });
};

export const calculateExtendedTrendLine = (
  data: (number | null)[],
): (number | null)[] => {
  const validData: { index: number; value: number }[] = [];
  data.forEach((value, index) => {
    if (value !== null && value !== undefined && !isNaN(value)) {
      validData.push({ index, value });
    }
  });

  if (validData.length < 2) {
    return data.map(() => null);
  }

  const xValues = validData.map((item) => item.index);
  const yValues = validData.map((item) => item.value);

  const { slope, intercept } = linearRegression(xValues, yValues);

  return data.map((_, index) => {
    const trendValue = slope * index + intercept;
    return trendValue;
  });
};
